/**
 * outpost_props.ts — the generated OUTPOST props (the Hugging Face outpost
 * wave, 2026-09-17): each side's field base in a battle is built from a
 * dedicated set — modular wall panels, gate pillars, an aid station, a repair
 * bay, a bunkhouse, a comms mast and a turret in two pieces (a static
 * pedestal and a head that aims). Made by `tools/asset-pipeline/
 * gen-outpost-hf.py` (FLUX.1-schnell image → Hunyuan3D-2.1 textured mesh),
 * cooked by `cook-ceremony-props.mjs` with PROPS_SRC/PROPS_OUT into
 * `client/public/props/outpost/<key>.glb` + `manifest.json` — the same static
 * side-channel as the ceremony props (no registry row, no MinIO).
 *
 * Every prop is seated by its bounding box bottom-centre (the PIVOT law) and
 * scaled to a target height — or, for the wall panels, to the span LENGTH
 * along the base's local X. A key not cooked / not landed keeps the module's
 * previous piece (a registry prop or a box): the self-heal base.
 */
export const OUTPOST_PROP_DIR = 'props/outpost';

/** Prop keys and the height (m) the base scales them to. */
export const OUTPOST_PROPS: Record<string, { targetH: number; label: string }> = {
  outpost_wall: { targetH: 1.8, label: 'barricade wall panel' }, // a 1:2 upright panel — tiled by its own width along each side
  outpost_gate_post: { targetH: 2.6, label: 'gate pillar' },
  outpost_aid_station: { targetH: 3.0, label: 'aid station' },
  outpost_repair_bay: { targetH: 3.4, label: 'repair bay' },
  outpost_barracks: { targetH: 2.8, label: 'bunkhouse' },
  outpost_comms_mast: { targetH: 6.5, label: 'comms mast' },
  // The generated 'head' came back as a WHOLE turret on its own round base (seen on the contact sheet), so it is
  // the turret: one piece that aims about its seat. The separate pedestal prompt is unused.
  outpost_turret_head: { targetH: 2.0, label: 'automated turret' },
};
export type OutpostPropKey = keyof typeof OUTPOST_PROPS;

/** Which way the generated turret's barrel points in MODEL space, read off
 *  the contact sheet (render-glb-views.mjs, 2026-09-17: the muzzle faces the
 *  +Z camera) — the turret is turned so the barrel runs +Z, the aim axis. */
export const TURRET_HEAD_BARREL: 'x' | '-x' | 'z' | '-z' = 'z';

/** The URL of a prop file for the current page base. */
export function outpostPropUrl(file: string, baseUri: string): string {
  return new URL(`${OUTPOST_PROP_DIR}/${file}`, baseUri).toString();
}
